import { inject, observer } from "mobx-react";
import LoginComponent from "../../components/Authentication/LoginComponent/LoginComponent";

const Login = inject('loginStore','sharedStore')(observer(LoginComponent));

export default Login;
